import { type TomBadge } from '@/ui/primitives/estilos';
import { type ResultadoItemLote, type StatusLote } from '@fiscoai/contracts';

export const STATUS_LOTE: Record<StatusLote, { rotulo: string; tom: TomBadge }> = {
  RECEBIDO: { rotulo: 'Na fila', tom: 'neutro' },
  PROCESSANDO: { rotulo: 'Processando', tom: 'marca' },
  CONCLUIDO: { rotulo: 'Concluído', tom: 'sucesso' },
  CONCLUIDO_COM_ERROS: { rotulo: 'Concluído com avisos', tom: 'alerta' },
  FALHOU: { rotulo: 'Falhou', tom: 'perigo' },
};

/** Ordem de exibição dos contadores: o que entrou, depois o que precisa de atenção. */
export const RESULTADOS: readonly { valor: ResultadoItemLote; rotulo: string; tom: TomBadge }[] = [
  { valor: 'IMPORTADO', rotulo: 'Importados', tom: 'sucesso' },
  { valor: 'ATUALIZADO', rotulo: 'Atualizados', tom: 'info' },
  { valor: 'CHAVE_PENDENTE', rotulo: 'Aguardando XML', tom: 'marca' },
  { valor: 'CHAVE_JA_IMPORTADA', rotulo: 'Já tinham XML', tom: 'neutro' },
  { valor: 'DUPLICADO', rotulo: 'Repetidos', tom: 'neutro' },
  { valor: 'SEM_EMPRESA', rotulo: 'Sem empresa do grupo', tom: 'alerta' },
  { valor: 'NAO_SUPORTADO', rotulo: 'Layout não suportado', tom: 'alerta' },
  { valor: 'INVALIDO', rotulo: 'Inválidos', tom: 'perigo' },
  { valor: 'ERRO', rotulo: 'Erros', tom: 'perigo' },
];

export const ROTULO_RESULTADO = Object.fromEntries(RESULTADOS.map((r) => [r.valor, r])) as Record<
  ResultadoItemLote,
  (typeof RESULTADOS)[number]
>;

export const FORMATO_PLANILHA = {
  SEFAZ_NFE_DESTINADAS: 'Relatório de NF-e destinadas (SEFAZ)',
  GENERICA: 'Planilha de chaves',
} as const;

/** Ponto colorido de status/resultado (mesma escala de tons dos badges). */
export const PONTO_DO_TOM: Record<TomBadge, string> = {
  sucesso: 'bg-sucesso',
  info: 'bg-info',
  marca: 'bg-marca',
  neutro: 'bg-borda-forte',
  alerta: 'bg-alerta',
  perigo: 'bg-perigo',
};
